import './registerUser.css';

import FormRegister from '../../../Component/form_register/formRegister'

function RegisterUser() {
  return (
    <div>
      <FormRegister title="Créer un compte client" isPro={false} />
    </div>
  );
}

export default RegisterUser;